function icon_chevron() {

    return (
        <svg className="icon icon__chevron" xmlns="http://www.w3.org/2000/svg" 
            width="7.001px" height="13.001px" viewBox="4.499 1.499 7.001 13.001" enableBackground="new 4.499 1.499 7.001 13.001"
            xmlSpace="preserve">
            <path  d="M4.646,1.646C4.841,1.451,5.158,1.45,5.353,1.645c0,0,0,0,0.001,0.001l6,6
            c0.195,0.195,0.196,0.512,0.002,0.707c-0.001,0-0.001,0-0.002,0.001l-6,6c-0.195,0.195-0.513,0.195-0.708,0s-0.195-0.512,0-0.707
            L10.293,8L4.646,2.354C4.451,2.159,4.45,1.842,4.646,1.646C4.646,1.646,4.646,1.646,4.646,1.646z"/>
        </svg>
    )
}

export default icon_chevron